export const ANALYTICS = {
  EVENT_NAMES: {
    ACCOUNT_CREATED: 'Customer Account Created',
    ADD_DESSERTS_CLICKED: 'Add Desserts Clicked',
    ADD_DRINKS_CLICKED: 'Add Drinks Clicked',
    ADD_PHOTOGRAPHY_CLICKED: 'Add Photography Clicked',
    BACK_CLICKED: 'backClicked',
    BOOKING_COMPLETED: 'Booking Completed',
    BOOKING_VIEWED: 'Booking Viewed',
    BOOK_NOW_CTA_CLICKED: 'bookNowCtaClicked',
    BREADCRUMB_CLICKED: 'Breadcrumb Clicked',
    CANCELLED_REQUEST: 'Request Cancelled',
    CHANGED_EVENT_NAME: 'Changed Event Name',
    CHAT_CTA_CLICKED: 'chatCtaClicked',
    CHAT_TO_SUPPLIER: 'Chat To Supplier',
    CTA_CLICKED: 'CTA Clicked',
    CONTACT_DETAILS_CLICKED: 'contactDetailsClicked',
    CROSS_SELL_CAROUSEL_CTA_CLICKED: 'Cross-Sell Carousel CTA Clicked',
    DECLINE_QUOTE_MODAL_OPENED: 'Decline Quote Modal Opened',
    DEPOSIT_AMOUNT_CHANGED: 'depositAmountChanged',
    DISINTERMEDIATION_WARNING_SHOWN: 'Disintermediation Warning Shown',
    FAVOURITES_CTA_CLICKED: 'Favourites Banner CTA clicked',
    FAVOURITES_SUGGESTION_CTA_CLICKED:
      'Favourites Suggestion Banner CTA clicked',
    GET_QUOTES_CLICKED: 'Get Quotes clicked',
    MESSAGE_SUPPLIER_CTA_CLICKED: 'messageSupplierCtaClicked',
    MY_QUOTES_VIEW_QUOTE_CLICKED: 'My Quotes View Quote CTA Clicked',
    PAGE_VIEWED: 'Page Viewed',
    PAYMENT_DETAILS_EDIT_SELECTED: 'paymentDetailsEditSelected',
    PAYMENT_DETAILS_STARTED: 'paymentDetailsStarted',
    PAYMENT_OPTION_SELECTED: 'paymentOptionSelected',
    PAYMENT_PROTECTION_OPTION_CLICKED: 'paymentProtectionOptionClicked',
    PAYMENT_SUBMITTED: 'Payment submitted',
    PAYMENT_WALLET_SELECTED: 'paymentWalletSelected',
    PAY_BY_INVOICE_REQUEST_SUBMITTED: 'payByInvoiceRequestSubmitted',
    PROCEEDED_TO_PAYMENT: 'Proceeded To Payment',
    PUSHY_INCOMPLETES_MODAL_CLOSED: 'Pushy Incompletes Modal Closed',
    QUOTE_DECLINED: 'quote_declined',
    QUOTE_SHARED: 'Quote Shared',
    REFERRAL_SHARED: 'Referral Shared',
    REQUEST_HIDDEN: 'Request Hidden',
    REQUEST_QUOTE_CARD_CTA_CLICKED: 'requestCardCtaClicked',
    REQUEST_QUOTE_CTA_CLICKED: 'Request a Quote CTA Clicked',
    REQUEST_WORKFLOW_TAB_CLICKED: 'requestWorkflowTabClicked',
    SORT_OPTIONS_CHANGED: 'customerQuoteSortOptionsChanged',
    SUPPLIER_PROFILE_LINK_CLICKED: 'Supplier Profile Link Clicked',
    SUPPLIER_QUOTE_SUBMITTED: 'Supplier Quote Submitted',
    TOGGLE_EVENT_REQUEST_QUOTE_LIMITED_CLICKED: 'acceptingQuotesSettingChanges',
    TWILIO_CALL_INITIATED: 'twilioCallInitiated',
    EVENT_CANCELLED: 'Event Cancelled',
  },
  PROPERTY_NAMES: {
    EVENT_NAME: 'eventName',
    PAGE_NAME: 'pageName',
  },
  PAGE_NAMES: {
    ACCOUNT_SETTINGS: 'accountSettings',
    BOOKING: 'bookingPage',
    BOOKING_REVIEW: 'bookingReview',
    CONVERSATION: 'conversation',
    DASHBOARD: 'dashboard',
    EVENT_EDIT: 'eventPageEdit',
    EVENT_PAGE: 'eventPage',
    EVENT_REQUEST: 'eventRequest',
    MESSAGING_VIEW: 'messagingView',
    MY_BOOKINGS: 'myBookings',
    MY_FAVOURITES: 'myFavourites',
    MY_PAYMENT: 'myPayment',
    MY_PAYMENTS: 'myPayments',
    PAYMENT: 'checkout',
    QUOTE: 'quotePage',
    QUOTE_VIEW: 'quoteView',
  },
  PAGE_CONTEXT: {
    BOOK_NOW: {
      WARNING_MODAL: 'dateFlexibleWarningModal',
    },
    MESSAGING_VIEW: {
      THREAD_CARD: 'messagingThreadCard',
      SIDEBAR: 'messagingSidebar',
    },
    QUOTE_VIEW: {
      QUOTE_BODY: 'quoteBody',
      QUOTE_FOOTER: 'quoteStickyFooter',
      QUOTE_ITEM_DRAWER: 'quoteItemDrawer',
    },
    QUOTE_CARD_CTA_CLICKED: {
      MESSAGE: 'message',
      VIEW_QUOTE: 'viewQuote',
      VIEW_BOOKING: 'viewBooking',
      QUOTE_CARD: 'quoteCard',
    },
  },
};

export type QuoteCardCtas = typeof ANALYTICS.PAGE_CONTEXT.QUOTE_CARD_CTA_CLICKED[keyof typeof ANALYTICS.PAGE_CONTEXT.QUOTE_CARD_CTA_CLICKED];
